<template>
  <div class="container mx-auto">
    <div class="mx-4 mt-8">
      <doe-page-heading label="Now, lets register your service/s" description="A centre director or nominated supervisor will need to register to be the service administrator on the Self-Assessment and Quality Improvement Planning 
Portal. The administrator is responsible for managing access for users (educators) at the service." class="mb-6" />
      <ol>
        <doe-stepper-block :step="1" :completed="true">
          <h5 class="font-bold font-sans text-blue-900 mb-1">Enter your name and contact details</h5>
        </doe-stepper-block>
        <doe-stepper-block :step="2" :completed="true">
          <h5 class="font-bold font-sans text-blue-900 mb-1">Confirm your identity</h5>
        </doe-stepper-block>
        <doe-stepper-block :step="3" :completed="false">
          <h5 class="font-bold font-sans text-blue-900 mb-1">Register your service/s</h5>
          <p class="font-sans text-blue-900 mb-4">
            We’ll need to verify and link you to any services you manage. You will
            need access to the service email address in
            <a
              class="underline"
              href="https://public.nqaits.acecqa.gov.au/Pages/Landing.aspx"
              target="_blank"
              >NQA ITS<span class="sr-only">Opens external website</span></a
            >.
          </p>
          <doe-button appearance="primary" @click="navRegister()">Register your service</doe-button>
        </doe-stepper-block>
        <doe-stepper-block :step="4" :completed="false" :finalStep="true" class="mb-6">
          <h5 class="font-bold font-sans text-blue-900 mb-1">Add your educators</h5>
        </doe-stepper-block>
      </ol>
      <doe-page-heading
        label="Need support?"
        description="See the [User Guide](/assets/Self Assessment and Quality Improvement Planning Portal User Guide.pdf) for detailed steps and guidance on accessing the Self-Assessment and Quality Improvement Planning 
Portal."
      />
    </div>
  </div>
</template>

<script>
import { serviceCallWithAuth } from "@/helpers/cognito";
import DoePageHeading from "@/components/typography/PageHeading";
import DoeStepperBlock from "@/components/typography/StepperBlock";
import DoeButton from "@/components/button/Button";

export default {
  name: "OnboardingServices",
  inject: {
    $validator: "$validator"
  },
  components: {
    DoePageHeading,
    DoeStepperBlock,
    DoeButton
  },
  mounted() {
    if (this.aclArray.length > 0 && this.aclArray.some(role => !role.match(/SE-00000000 TTSDS Director/))) {
      return this.$router.push({ name: "service-dashboard" });
    }
    if(!this.aclArray.length){
      const headers = this.$OAuth.buildHttpHeader();
      const body = {
        op: "add",
        seNumber: "SE-00000000",
        role: "Director"
      };
      let options = {
        path: `/users/${this.profile.detuserguid}`,
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(body)
      };
      serviceCallWithAuth("doe-ttss", options);
    }
  },
  computed: {
    profile() {
      return this.$OAuth.data.profile;
    },
    aclArray() {
      if(this.profile && this.profile.acl) {
        return Array.isArray(this.profile.acl) ? this.profile.acl : [this.profile.acl];
      }
      return [];
    }
  },
  methods: {
    navRegister() {
      this.$router.push({ name: "service-register" });
    }
  }
};
</script>

<style lang="scss" scoped>
p /deep/ a {
  @apply inline-block relative underline;
}
p /deep/ a[href*="//"]:not([href*="localhost.com"]) {
  padding-right: 1.5rem;
  &:after {
    @apply absolute block;
    content: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 100 89'><path d='M100,4.16666667 L100,26.3861111 C100,30.1119792 95.4930556,31.9381944 92.8869792,29.3324653 L86.6878472,23.1329861 L44.4095486,65.4112847 C42.7822917,67.0385417 40.1442708,67.0385417 38.5170139,65.4112847 L34.5887153,61.4829861 C32.9614583,59.8557292 32.9614583,57.2175347 34.5887153,55.5904514 L76.8673611,13.3118056 L70.6689236,7.11302083 C68.0524306,4.49652778 69.9055556,0 73.6152778,0 L95.8333333,0 C98.1345486,0 100,1.86545139 100,4.16666667 Z M70.6647569,47.0128472 L67.8869792,49.790625 C67.1055707,50.5720468 66.6666073,51.6318913 66.6666667,52.7369792 L66.6666667,77.7777778 L11.1111111,77.7777778 L11.1111111,22.2222222 L56.9444444,22.2222222 C58.049457,22.2221592 59.1092025,21.783211 59.890625,21.0019097 L62.6684028,18.2241319 C65.2932292,15.5991319 63.4342014,11.1111111 59.7222222,11.1111111 L8.33333333,11.1111111 C3.73090278,11.1111111 0,14.8420139 0,19.4444444 L0,80.5555556 C0,85.1579861 3.73090278,88.8888889 8.33333333,88.8888889 L69.4444444,88.8888889 C74.046875,88.8888889 77.7777778,85.1579861 77.7777778,80.5555556 L77.7777778,49.9590278 C77.7777778,46.246875 73.2895833,44.3878472 70.6647569,47.0128472 Z' /></svg>");
    top: 0px;
    right: 0px;
    width: 1.25rem;
    height: 1.25rem;
  }
}
</style>
